module.exports = __webpack_public_path__ + "static/media/bank.4ef0af36.png";